<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">

    <cql-headerbar/>

    <!-- CREATING NEW JOB -->
    <div class="lightbox" v-if="createNewModal">
        <div class="lightbox-box flex-column bg-color-darkgray py3 px1 rounded-border max-width-4 mt4">
            <button class="lightbox-close-btn" @click="createNewModal = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2 class="h3 white regular center mb4">Neuen Job erstellen</h2>
            <div class="flex">
            <input class="user-input  mb2 mr1" placeholder="Name" v-model="createNewModal_newJobName">
            <input class="user-input  mb2 mr1" placeholder="Beschreibung" v-model="createNewModal_newJobDescription">
            <a class="btn btn-primary" @click="createNewObj()">OK</a>
            </div>
        </div>
    </div>

    <!-- EDITING EXISTING JOB -->
    <div class="lightbox" v-if="openJobEditModal">
        <div class="lightbox-box flex-column bg-color-darkgray py3 px1 rounded-border max-width-4 mt4">
            <button class="lightbox-close-btn" @click="openJobEditModal = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2 class="h3 white regular center mb4">Job bearbeiten</h2>
            <div class="flex">
            <input class="user-input  mb2 mr1" placeholder="Name" v-model="editJobTitle">
            <input class="user-input  mb2 mr1" placeholder="Beschreibung" v-model="editJobDescription">
            <a class="btn btn-primary" @click="editObj()">OK</a>
            </div>
        </div>
    </div>

    <div class="col-12 flex flex-end px4 pt4 border-box">
      <div class="flex align-middle pointer" v-on:click="newJobModal()">
        <div class="bg-color-cta p1 relative" style="border-radius: 30px; height:30px; width:30px">
          <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="white p-small ml1 mr4">Neuer Job</p>
      </div>

      <!-- <div class="flex align-middle  pointer">
        <div class="bg-color-cta p1 relative" style="border-radius: 30px; height:30px; width:30px">
          <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.247 5.25H21.747C22.5755 5.25 23.247 5.92157 23.247 6.75V21.75C23.247 22.5784 22.5755 23.25 21.747 23.25H8.24704C7.41861 23.25 6.74704 22.5784 6.74704 21.75V15.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.747 9.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.497 14.25H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.5 18.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25004 9.75V6.75L12.439 2.561C12.7423 2.25756 12.833 1.80138 12.6688 1.40504C12.5047 1.0087 12.118 0.750194 11.689 0.75H1.81104C1.38205 0.750194 0.995395 1.0087 0.831256 1.40504C0.667117 1.80138 0.757798 2.25756 1.06104 2.561L5.25004 6.75V12.75L8.25004 9.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="white p-small ml1">Filter</p>
      </div> -->
    </div>

    <div class="px4">
      <div class="flex align-middle ml2 mb4">
        <router-link class="house-button pointer" :to="'/' + this.$i18n.locale + '/projects'">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 8.4V3.5C20.5 3.22385 20.2761 3 20 3H18C17.7239 3 17.5 3.22385 17.5 3.5V5.64L13.338 1.811C13.1465 1.63437 12.8515 1.63437 12.66 1.811L1.66001 12.132C1.50816 12.2717 1.45769 12.4903 1.53294 12.6824C1.60818 12.8745 1.79369 13.0006 2.00001 13H4.50001V22.5C4.50001 23.0523 4.94772 23.5 5.50001 23.5H20.5C21.0523 23.5 21.5 23.0523 21.5 22.5V13H24C24.2061 13.0002 24.3913 12.8739 24.4663 12.6819C24.5412 12.4899 24.4907 12.2715 24.339 12.132L20.5 8.4Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
      <div class="flex align-baseline">
        <h3 class="caps p-small narrow color-gray mx2 regular">Projekt</h3>
        <router-link class="white h3 regular" :to="'/' + this.$i18n.locale + '/projects'">{{project.title}}</router-link>
      </div>

      </div>
      <h1 class="h0 regular white mb3 ml2">Jobs</h1>
      <div class="flex flex-wrap max-width-7 op0" style=" transition: opacity .3s ease .3s;" :class="{op100: jobs.length !== 0, absolute: jobs.length !== 0}">
        <job-card 
          v-for="job in jobs" :key="job.id"
          :id="job.id"
          :title="job.title"
          :subtitle="job.subtitle"
          :lastChanged="job.lastChanged"
          :calcCount="job.calcCount"
        />
      </div>
      <div class="ml2 pt4 op0 absolute" style="transition: opacity .3s ease .3s;" :class="{op100: fetchedJobs == false, npe: fetchedJobs == true}">
        <h2 class="h1 light white mb2">Noch keine Jobs vorhanden.</h2>
        <button class="btn btn-primary" v-on:click="newJobModal()">Neuen Job erstellen</button>
      </div>
      <div class="synchronising-box bg-color-darkgray px4 py3 max-width-1 mx-auto flex flex-column justify-center drop-shadow rounded-border" :class="{hidden: jobs.length !== 0 || fetchedJobs == false}">
        <div class="flex justify-center mb3">
        <img src="../assets/cql_logo.png">
        </div>
        <div class="mx-auto mt3 mb3 spinning relative">
          <svg class="synchro-arrows" width="70" height="70" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.7496 19.9889L28.8755 14.5788L25.0479 20.773" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M28.8505 14.6473C30.8379 22.2118 26.3273 29.9576 18.7673 31.9624" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.64827 1L5.92969 7.75154L13.1731 8.47289" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.94922 7.73741C11.8941 2.63272 20.8455 3.28748 25.9843 9.2029" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.43481 33L10.6383 31.9465L7.60463 25.3261" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.5395 31.8865C3.15258 29.3364 -0.770083 21.2824 1.77646 13.8943" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h4 class="h4 regular white center mt3">Synchronisiere</h4>
      </div>
    </div>
  </div>
</template>

<script>
import cqlHeaderbar from './cqlHeaderbar.vue';
import JobCard from './JobCard.vue';

import { EventBus } from "../event-bus";
import axios from 'axios'

export default {
  name: "JobsOverview",
  data() {
    return {
      jobs: [
      ],
      project: {},
      
      fetchedJobs: null,
      createNewModal: false,
      createNewModal_newJobName: '',
      createNewModal_newJobDescription: '',

      openJobEditModal: false,
      editJobTitle: '',
      editJobDescription: '',
      editJobId: ''
    };
  },
  created: function () {
    // console.log('JobsOverview created.')
    EventBus.$on('loginSuccessful', (payload) => {
      
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
    });
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      // console.log('JobsOverview.vue recieved Event: "loginSuccessful"!');
      this.userdata = payload.userdata;
      this.username = payload.userdata.company  + " " + payload.userdata.firstname + " " + payload.userdata.name;
      this.session = payload.session;
      this.loginStatus = true;

      this.loadJobList();

      this.loadProjectHead();

    });

    EventBus.$on('cloneJob', (payload) => {
      //console.log('cloneJob.event recieved at Component: JobsOverview!');
      let currentObj = this;
      let data = {jobid: payload.id};
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/job-actions/clone/json', merged)
        .then(currentObj.loadJobList());
    });

    EventBus.$on('removeJob', (payload) => {
      let currentObj = this;
      let data = {jobid: payload.id};
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/job-actions/remove/json', merged)
        .then(currentObj.loadJobList());
    });
    EventBus.$on('editJobSettings', (payload) => {
      this.openJobEditModal = true
      this.editJobTitle = payload.title
      this.editJobDescription = payload.subtitle
      this.editJobId = payload.id
    });

    EventBus.$on('loginNotCorrect', () => {
      this.$router.push({ path:'/'});
    });
  }, 
  mounted: function () {
    // console.log('loginCheckQaL');
    EventBus.$emit('loginCheckQaL', {
    });
  },
  beforeDestroy () {
    EventBus.$off('cloneJob');
    EventBus.$off('removeJob');
    //EventBus.$off('loginSuccessful');
    //EventBus.$off('loginSuccessfulSubComponents');
  },
  methods: {
    loadProjectHead() {
      //console.log('loadProjectHead.called()');
      let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/project-actions/load/json';

      let currentObj = this;
      let data = {};
      data.projectid = this.$route.params.projectid;

      let merged = {...data, ...this.session};

      axios.post(url, merged)
        .then(response => {
         currentObj.project = response.data;
         //console.log(currentObj.project)
      }).catch(function () { currentObj.log('catch Function of AJAX-Called... error()');  });
    },
    loadJobList() {
      //console.log('loadJobList.called()');
      let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/job-list/json';

      let currentObj = this;

      let data = {};
      data.projectid = this.$route.params.projectid;

      let merged = {...data, ...this.session};

      axios.post(url, merged)
        .then(response => {
         currentObj.jobs = response.data.jobs;

        if(response.data.jobs.length == 0){
          currentObj.fetchedJobs = false
        }else{
          currentObj.fetchedJobs = true
        }

        })
        .catch(function () {
          currentObj.log('catch Function of AJAX-Called... error()');
          
        });

    },
    newJobModal() {
        this.createNewModal = true;
    },
    editObj(){
      let currentObj = this;
      let data = {};
      console.log(data)
      data.name = this.editJobTitle;
      data.description = this.editJobDescription;
      data.jobid = this.editJobId;
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/job-actions/update/json', merged).then(function () {currentObj.loadJobList(); currentObj.openJobEditModal = false;}  );
    },
    createNewObj() {
      let currentObj = this;
      let data = {};
      data.title = this.createNewModal_newJobName;
      data.description = this.createNewModal_newJobDescription;
      data.project_id = this.$route.params.projectid;
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/job-actions/add/json', merged)
        .then(function() {currentObj.loadJobList(); currentObj.createNewModal = false;});
    }
  
  },
  components: {
    'job-card': JobCard,
    'cql-headerbar':cqlHeaderbar,
  },

};
</script>
<style scoped>
</style>